module.exports = __webpack_public_path__ + "img/IMG_1039_L_WoodMatted.88eb9f69.jpg";